import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  tncData: {},
  isLoading: false,
  error: "",
  hasData: false,
  tncDataStatus: {
    status: false
  }
};
const paymentTncSlice = createSlice({
  name: "termsandConditions",
  initialState,
  reducers: {
    getTncRequest: state => {
      state.isLoading = true;
    },
    tncSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.tncData = action.payload;
      state.tncDataStatus.status = true;
    },
    tncFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.hasData = true;
      state.tncData = {};
      state.tncDataStatus.status = false;
    },
    resetTncData: state => {
      state.isLoading = false;
      state.error = "";
      state.hasData = false;
      state.tncData = {};
      state.tncDataStatus.status = false;
    }
  }
});
export const {
  getTncRequest,
  tncSuccess,
  tncFailure,
  resetTncData
} = paymentTncSlice.actions;
export default paymentTncSlice.reducer;